
<Modal
  :visible="visible"
  centered
  :width="450"
  :class="$style.switchAccountDialog"
  @cancel="handleClose"
>
  <template #title>
    <div :class="$style['switch-title']">
      <i :class="$style['switch-title-icon']"></i>
      <div :class="$style['switch-title-text']">
        {{ $t('2570e0f00b') }}
      </div>
    </div>
  </template>
  <div :class="$style['switch-content']">
    「{{ companyName }}」{{ $t('40d16a007e') }}
    <img :class="$style['switch-content-logo']" :src="userLogo" />
    <span :class="$style['switch-content-name']">{{ userName }}</span>
    {{ $t('81376b92e4') }}
  </div>
  <template #footer>
    <div :class="$style['switch-footer']">
      <Button
        :class="$style['switch-footer-btn']"
        type="primary"
        @click="handleClick"
      >
        {{ $t('ba679ba739', ['']) }}
      </Button>
      <div :class="$style['switch-footer-time']">
        {{ $t('c05f64c6c6', [`${times}s`]) }}
      </div>
    </div>
  </template>
</Modal>
